import React from "react"
import {useParams} from "react-router-dom";
import {ResidenceService} from "../../../service/residence/ResidenceService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {useState} from "react";
import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer,
    RaikoCreatorInfo,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoNumberInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    RaikoSimpleMultiLineInputOutlined,
    showErrorMessage,
    showServerErrorMessage,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import LanguageSelector from "../../../component/languageSelector/LanguageSelector";

export default function ResidenceDetailBasicInfo() {

    const {id: residenceId} = useParams()

    const service = new ResidenceService();
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [languageId, setLanguageId] = useState();

    const [title, setTitle] = useState("")
    const [menCapacity, setMenCapacity] = useState(0)
    const [womenCapacity, setWomenCapacity] = useState(0)

    const [address, setAddress] = useState("")

    const [createdAt, setCreatedAt] = useState("")
    const [createdBy, setCreatedBy] = useState("")

    function getResidenceInfoFromServer(languageCode) {
        loading.show()
        service.getResidenceDetail(residenceId, languageCode ? languageCode : languageId)
            .then((res) => {
                setTitle(res.metaData && res.metaData.title ? res.metaData.title : "")
                setMenCapacity(res.menCapacity)
                setWomenCapacity(res.womenCapacity)
                setAddress(res.metaData && res.metaData.address ? res.metaData.address : "")

                setCreatedAt(convertUniversalDateTimeToPersianDateTime(res.createdAt))
                setCreatedBy(res.createdBy)

            }).catch((err) => {

            showErrorMessage(detectServerErrorMessage(err))
        }).finally(() => {
            loading.hide()
        })
    }


    function handleUpdateInfo() {
        loading.show()
        service.updateInfo(
            residenceId,
            languageId,
            title,
            menCapacity,
            womenCapacity,
            address,
        ).then(response => {
            showSuccessMessage("بروزرسانی با موفقیت انجام شد")
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(() => {
            loading.hide()
        })
    }

    return (
        <RaikoGridOneColumn>
            <LanguageSelector languageId={languageId} setLanguageId={setLanguageId}
                              handleGetInfo={getResidenceInfoFromServer}/>

            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"اطلاعات پایه"}
                    subTitle={"اطلاعات پایه ی اقامتگاه"}
                    hasActionButton
                    actionButtonOnclickWithValidation={handleUpdateInfo}
                >
                    <RaikoGridThreeColumn>
                        <RaikoSimpleInputOutlined
                            labelText={"نام"}
                            value={title}
                            setValue={setTitle}
                            required
                        />
                        <RaikoNumberInputOutlined
                            labelText={"ظرفیت آقا"}
                            value={menCapacity}
                            setValue={setMenCapacity}
                            required
                        />
                        <RaikoNumberInputOutlined
                            labelText={"ظرفیت خانم"}
                            value={womenCapacity}
                            setValue={setWomenCapacity}
                            required
                        />
                    </RaikoGridThreeColumn>
                    <RaikoSimpleMultiLineInputOutlined
                        labelText={"نشانی"}
                        value={address}
                        setValue={setAddress}
                        rows={3}/>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>

            <RaikoCreatorInfo
                createdBy={createdBy}
                createdAt={createdAt}
            />

        </RaikoGridOneColumn>
    )

}